export default __webpack_public_path__ + "static/media/Imp_hitch_avl_yl.4ec032b9.svg";